import { abilitiesPlugin } from '@casl/vue';
import abilityFor from '@/config/ability';
import { loadStorageItem } from '@/services/storage';
import { GUEST } from '@/constants/roles';

const role = loadStorageItem('app:role') || GUEST;
const ability = abilityFor(role, []);

export function installCasl(app) {
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  });
}

export default ability;
